import axios from 'axios';
import Vue from 'vue';
import router from '../../../router'
import store from '@/assets/common/store'
import moment, { now } from 'moment-timezone'
import 'element-ui/lib/theme-chalk/index.css'
import state from '@/assets/common/store/state.js'; //状态管理

//build编译用地址
let serveHost = window.location.protocol + "//" + window.location.host;
let baseUrl = process.env.NODE_ENV === 'production' ? serveHost : '';
axios.defaults.baseURL = baseUrl;
axios.defaults.timeout = 300000 // 将超时时间修改为3分钟

// 拦截request,设置全局请求为ajax请求
axios.interceptors.request.use((config) => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  return config;
})
// 拦截request,设置全局请求为ajax请求
axios.interceptors.response.use((res) => {
  if (res.data.errcode == '401') {
    window.localStorage.clear()
    router.push({ path: '/Login' });
  } else {
    return res
  }

})
// 错误信息
let msg = '系统繁忙，请稍等！';

function errorTips(message) {
  if (document.getElementsByClassName('el-message').length === 0) {
    Vue.prototype.$message({
      message: message,
      type: 'error'
    });
  }
}

const httpServe = {};
httpServe.serveHost = baseUrl;
httpServe.getOms = function (url) {
  return httpServe.serveHost + '/oms' + url
}
httpServe.getOsv = function (url) {
  return httpServe.serveHost + '/osv' + url
}
httpServe.getUms = function (url) {
  return httpServe.serveHost + '/ums' + url
}
httpServe.getSchedule = function (url) {
  return httpServe.serveHost + '/schedule' + url
}
httpServe.getFile = function (url) {
  return httpServe.serveHost + '/file' + url
}
httpServe.getPlatformUrl = function (url) {
  return `${SERVER_HOST}/platform${url}`;
}
httpServe.getApiUrl = function (url) {
  return httpServe.serveHost + url;
}
// 保存token
httpServe.setToken = function (token) {
  let me = this;
  if (token !== null && token !== undefined) {
    if (token['access_token']) {
      window.localStorage.setItem("LISTINGCHECK_OMS_access_token", token.access_token);
    }
    if (token['access_overtime']) {
      window.localStorage.setItem("LISTINGCHECK_OMS_access_overtime", token['access_overtime']);
    }
    if (token['refresh_token']) {
      window.localStorage.setItem("LISTINGCHECK_OMS_refresh_token", token.refresh_token);
    }
    if (token['refresh_overtime']) {
      window.localStorage.setItem("LISTINGCHECK_OMS_refresh_overtime", token.refresh_overtime);
    }
    if (token['companyId']) {
      window.localStorage.setItem("LISTINGCHECK_OMS_companyId", token.companyId);
    }
    window.localStorage.setItem("LISTINGCHECK_OMS_expires_in", token.expires_in * 1000);
    state.IsLogin = true;
  }
};

// 获取token
httpServe.getToken = async function () {
  let me = this;
  let access_token = await window.localStorage.getItem("LISTINGCHECK_OMS_access_token");
  if (access_token) {
    let overtime = parseInt(await window.localStorage.getItem('LISTINGCHECK_OMS_access_overtime')) + parseInt(window.localStorage.getItem('LISTINGCHECK_OMS_expires_in'));
    let refresh_token = await window.localStorage.getItem('LISTINGCHECK_OMS_refresh_token');
    if (overtime < new Date().getTime()) {  //token过期
      if (refresh_token) {
        let url = me.getApiUrl('/oauth/token');
        let res = await me.refreshToken(url, refresh_token);
        if (res && res['data']['access_token']) {
          res.data.access_overtime = Date.now()
          await me.setToken(res['data']);
          let token = window.localStorage.getItem("LISTINGCHECK_OMS_access_token")
          return token;
        } else {
          return '';
        }
      } else {
        return '';
      }
    } else {
      return access_token;
    }
  } else {
    return '';
  }
}
// 刷新token
httpServe.refreshToken = async function (url, refresh_token) {
  let headers = {
    'Authorization': 'Basic b21zOm9tc3NlY3JldA==',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    // 'VC': 'oauth'
  }
  let params = {
    grant_type: 'refresh_token',
    scope: 'all',
    type: 'account',
    refresh_token: refresh_token
  }
  let config = {
    url: url,
    method: 'post',
    headers: headers,
    params: params
  }

  let rs = null
  await axios.request(config).then(res => {
    rs = res
  }).catch(e => {
    rs = e.response
  })
  return rs
}
// GET请求
httpServe.ajaxGet = async function (url, params = {}, needToken = true) {
  let headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  if (needToken) {
    headers.Authorization = 'Bearer ' + await this.getToken();
  }
  if (url.indexOf('/pub/loadcode?groups=FinanceItemCode') > -1 || url.indexOf('/pub/loadcode?groups=FinanceBizType') > -1) {
    headers.project = 'customer';
  }
  let rs = null;
  await axios.get(url, {
    params,
    headers: headers,
  }).then(res => {
    rs = res;
  }).catch(e => {
    rs = e.response;
  });
  rs = await this.checkResponse(rs);
  if (rs.data && rs.data.systemTime) { // 设置全局的服务器的当前时间
    httpServe.setNowSystemTime(rs.data.systemTime);
  }
  return rs;
};
// POST请求
httpServe.ajaxPost = async function (url, param = {}, needToken = true) {
  let headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  if (needToken) {
    headers.Authorization = 'Bearer ' + await this.getToken();
  }
  let rs = null;
  await axios.post(url, param, { headers: headers, timeout: 300000 }).then(res => {
    rs = res;
  }).catch(e => {
    rs = e.response;
  });
  rs = await this.checkResponse(rs);
  if (rs && rs.systemTime) { // 设置全局的服务器的当前时间
    httpServe.setNowSystemTime(rs.systemTime);
  }
  return rs;
};

// POST请求
httpServe.ajaxPostForm = async function (url, param = {}, needToken = true) {
  let headers = {
    "Access-Control-Allow-Origin": "*",
  };
  if (needToken) {
    headers.Authorization = 'Bearer ' + await this.getToken();
  }
  let rs = null;
  await axios.post(url, param, { headers: headers, timeout: 300000 }).then(res => {
    rs = res;
  }).catch(e => {
    rs = e.response;
  });
  rs = await this.checkResponse(rs);
  if (rs && rs.systemTime) { // 设置全局的服务器的当前时间
    httpServe.setNowSystemTime(rs.systemTime);
  }
  return rs;
};
/**
 * 登录
 * @param {*} url 
 * @param {*} param 
 * @param {*} needToken 
 */
httpServe.login = async function (url, params) {

  let headers = {
    'Authorization': 'Basic b21zOm9tc3NlY3JldA==',
    'Content-Type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Origin': '*',
    'VC': 'oauth'
  };
  let rs
  await axios.request({
    url: url,
    method: 'post',
    headers: headers,
    params: params
  }).then(res => {
    rs = res;
  }).catch(e => {
    rs = e.response;
  });
  rs = await this.checkResponse(rs);
  if (rs.data && rs.data.systemTime) { // 设置全局的服务器的当前时间
    httpServe.setNowSystemTime(rs.data.systemTime);
  }
  return rs;
}
httpServe.ajaxGetFile = async function (url, param = {}, needToken = true) {
  let headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  };
  if (needToken) {
    headers.Authorization = 'Bearer ' + await this.getToken();
  } else {
    headers.Authorization = http.Authorization
  }
  var request = new Promise(function (resolve, reject) {
    axios({
      method: 'GET',
      url: url,
      params: param,
      headers: headers,
      responseType: 'blob'
    }).then((res) => {
      resolve(res)
    }).catch(async (error) => {
      resolve(error)
    })
  });
  let res = await request;
  this.checkResponse(res);
  return res;
};
/**
 * POST下载文件
 * @param url
 * @param param
 * @param needToken
 * @returns {Promise<void>}
 */
httpServe.ajaxPostFile = async function (url, param = {}, needToken = true) {
  let headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  };
  if (needToken) {
    headers.Authorization = 'Bearer ' + await this.getToken();
  }
  let rs = null;
  await axios.post(url, param, { headers: headers, responseType: 'blob' }).then(res => {
    rs = res['data'];
  }).catch(error => {
    rs = error['data'];
  });
  rs = await this.checkResponse(rs);
  if (rs.data && rs.data.systemTime) { // 设置全局的服务器的当前时间
    httpServe.setNowSystemTime(rs.data.systemTime);
  }
  console.log(rs)
  return rs;
};

httpServe.setNowSystemTime = function (time) {
  if (time) { // 设置全局的服务器的当前时间
    window.sessionStorage.setItem("systemTime", time);
    store.commit('setNowSystemTime', Number(moment(time).format("x")));
  }
}
/**
 * 获取下载文件名
 * @param res 请求返回的数据
 * @returns {string | *}
 */
httpServe.getFileName = function (res) {
  let filename = res['headers']['content-disposition'];
  let index = filename.indexOf('filename=');
  filename = filename.substring(index + 'filename='.length);
  return filename;
}
/**
 * 获取下载文件格式
 * @param res 请求返回的数据
 * @returns {string | *}
 */
httpServe.getFileType = function (data) {
  let type = '';
  switch (data.data.type) {
    case 'application/andrew-inset':
      type = '.ez';
      break;
    case 'application/mac-binhex40':
      type = '.hqx';
      break;
    case 'application/mac-compactpro':
      type = '.cpt';
      break;
    case 'application/msword':
      type = '.doc';
      break;
    case 'application/octet-stream':
      type = '.exe';
      break;
    case 'application/oda':
      type = '.oda';
      break;
    case 'application/pdf':
      type = '.pdf';
      break;
    case 'application/postscript':
      type = '.ps';
      break;
    case 'application/smil':
      type = '.smil';
      break;
    case 'application/vnd.mif':
      type = '.mif';
      break;
    case 'application/vnd.ms-excel':
      type = '.xlsx';
      break;
    case 'application/vnd.ms-powerpoint':
      type = '.ppt';
      break;
    case 'application/vnd.wap.wbxml':
      type = '.wbxml';
      break;
    case 'application/vnd.wap.wmlc':
      type = '.wmlc';
      break;
    case 'application/vnd.wap.wmlscriptc':
      type = '.wmlsc';
      break;
    case 'application/x-bcpio':
      type = '.bcpio';
      break;
    case 'application/x-cdlink':
      type = '.vcd';
      break;
    case 'application/x-chess-pgn':
      type = '.pgn';
      break;
    case 'application/x-cpio':
      type = '.cpio';
      break;
    case 'application/x-csh':
      type = '.csh';
      break;
    case 'application/x-director':
      type = '.dir';
      break;
  }
  return type;
};

/**
 * POST下载文件
 * @param data
 */
httpServe.download = function (data, filename = 'excel') {
  if (!data) {
    return
  }
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', filename)

  document.body.appendChild(link);
  link.click()
};

httpServe.upload = async function (url, file, needToken = true) {
  let headers = {
    'Content-Type': 'multipart/form-data',
    "Access-Control-Allow-Origin": "*",
  };
  if (needToken) {
    headers.Authorization = 'Bearer ' + await this.getToken();
  }
  let postData = new FormData();
  postData.append('file', file);
  let rs = null;
  await axios.post(url, postData, { headers: headers }).then(res => {
    rs = res;
  }).catch(e => {
    rs = e.response;
  });
  if (rs.data && rs.data.systemTime) { // 设置全局的服务器的当前时间
    httpServe.setNowSystemTime(rs.data.systemTime);
  }
  return rs;
};
httpServe.uploadByFormData = async function (url, postData, needToken = true) {
  let headers = {
    'Content-Type': 'multipart/form-data',
    "Access-Control-Allow-Origin": "*",
  };
  if (needToken) {
    headers.Authorization = 'Bearer ' + await this.getToken();
  }

  let rs = null;
  await axios.post(url, postData, { headers: headers }).then(res => {
    rs = res;
  }).catch(e => {
    rs = e.response;
  });
  if (rs.data && rs.data.systemTime) { // 设置全局的服务器的当前时间
    httpServe.setNowSystemTime(rs.data.systemTime);
  }
  return rs;
};

httpServe.ajaxUpload = async function (url, params, needToken = false) {
  const me = this;
  let headers = {
    'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'auth': '0'
  }
  if (needToken) {
    headers['auth'] = '1';
  }
  var request = new Promise(function (resolve, reject) {
    axios({
      method: 'POST',
      url: url,
      data: params,
      headers: headers,
      // responseType: 'blob'
    }).then((res) => {
      resolve(res['data'])
    }).catch((err) => {
      if (err['response']) {
        resolve(err['response']['data'])
      }
    })
  });
  let res = await request;
  if (!res.success) {
    me.checkResponse(res)

  } else {
    Vue.prototype.$message({
      message: '上传成功',
      type: 'success'
    });
  }
  return res;
}
// 请求状态处理
httpServe.checkResponse = function (res) {
  if (res && !res['success']) {
    switch (res['errcode']) {
      case '400':
        popup.showMessage('请求错误', 'error')
        break;

      case '401':
        // token过期，从callback页面重新登录
        // storage.clearStorage();
        // router.replace({ name: 'callback' });
        http.getLogin();
        break;
      case '600':
      case '610':
        http.getLogin()
        // storage.clearStorage();
        // router.replace({ name: 'callback' });
        break;

      case '403':
        popup.showMessage('拒绝访问', 'error')
        break;

      case '404':
        // popup.showMessage(`请求地址出错: ${res.config.url}`, 'error')
        popup.showMessage('请求地址出错', 'error')
        break;

      case '408':
        popup.showMessage('请求超时', 'error')
        break;

      case '500':
        const errmsg = res['errmsg']
        if (!errmsg || errmsg === '' || errmsg == null) {
          popup.showMessage('服务器异常，请稍后重试', 'error')
        } else if (errmsg && (errmsg.indexOf('I/O error') !== -1 || errmsg.indexOf('No instances available') !== -1)) {
          popup.showMessage('服务器重启，请稍后重试', 'error')
        } else if (errmsg != '用户名已存在' && errmsg != '未绑定Payoneer账号' && errmsg != 'Server unknown error') {
          popup.showMessage(errmsg, 'error')
        }
        break;

      case '501':
      case '502':
      case '503':
      case '504':
        popup.showMessage('系统繁忙，请稍等', 'error');
        break;

      case '505':
        popup.showMessage('HTTP版本不受支持', 'error');
        break;

      default:
        if (res['errmsg']) {
          popup.showMessage(res['errmsg'], 'error')
        }
        break;
    }
    return res;
  } else {
    return res;
  }

};

export default httpServe;
